import { TemplatePreviewProps } from './types';
import styles from './TemplatePreview.module.scss';
import { useTranslation } from 'react-i18next';
import React from 'react';

const TemplatePreview = ({ id, description, resolution, fines }: TemplatePreviewProps) => {
  const { t } = useTranslation();
  return (
    <div id={`${id ?? 'templatePreview'}`} className={styles.template_preview_container}>
      <div id={`${id ?? 'templatePreview'}Description`}>{description}</div>
      {fines && (
        <div id={`${id ?? 'templatePreview'}Fines`}>
          <strong id={`${id ?? 'templatePreview'}FinesLabel`}>{t('labels.fines')}:&nbsp;</strong>
          {fines}
        </div>
      )}
      {resolution && (
        <div id={`${id ?? 'templatePreview'}Resolution`} className={styles.flex_variant}>
          <strong id={`${id ?? 'templatePreview'}ResolutionLabel`}>
            {t('labels.resolutionCost')}:&nbsp;
          </strong>
          {resolution}
        </div>
      )}
    </div>
  );
};

export default TemplatePreview;
